// Configurable UI values. Change here — takes effect everywhere.
export const APP_CONFIG = {
  maxValidationAttempts: 5,       // Matches server-side AttemptLimitFilter threshold
  stepCount: 6,                   // Total steps — drives StepIndicator display
  pdfPollingIntervalMs: 2000,     // How often FormGeneration.tsx polls for PDF ready
  sessionTimeoutMs: 30 * 60 * 1000, // 30 min — inactivity timeout
  sessionWarningMs:  2 * 60 * 1000, // show warning 2 min before timeout
} as const;

export const IDENTITY_ERROR_MESSAGES: Record<string, string> = {
  INVALID_CAPTCHA:     'Invalid CAPTCHA. Please try again.',
  IDENTITY_MISMATCH:   'We are unable to process your request. Please verify your information and try again.\nIf you continue to experience issues, please contact your HR department for assistance.',
  TOKEN_INACTIVE:      'Your access link is no longer active. Please contact your employer.',
  RATE_LIMIT_EXCEEDED: 'Too many requests from your network. Please try again after 10 minutes.',
  ATTEMPT_FAILURE:     'Too many unsuccessful login attempts. Please try again after 15 minutes.',
  UNKNOWN_ERROR:       'An unexpected error occurred. Please try again.',
};

// User-facing error messages keyed by backend error codes.
export const ERROR_MESSAGES: Record<string, string> = {
  
  SCREEN_CANCEL:              'Thanks for visiting this site. Please try again with your access link.',
  /* 
  NO_TOKEN_PROVIDED:         'No access link was found. Please use the link provided in your email.',
  INVALID_TOKEN_FORMAT:      'The link appears to be malformed. Please use the original link from your email.',
  INVALID_TOKEN:             'This link is not valid. Please contact your employer to request a new link.',
  MISSING_CLAIMS:            'This link is not valid. Please contact your employer to request a new link.',
  */ 
  NO_TOKEN_PROVIDED:         'We’re unable to access this portal link. Please confirm you are using the most recent link provided by your employer.',
  INVALID_TOKEN_FORMAT:      'We’re unable to access this portal link. Please confirm you are using the most recent link provided by your employer.',
  INVALID_TOKEN:             'We’re unable to access this portal link. Please confirm you are using the most recent link provided by your employer.',
  MISSING_CLAIMS:            'We’re unable to access this portal link. Please confirm you are using the most recent link provided by your employer.',
  CLIENT_INACTIVE:           'We’re unable to access this portal link. Please confirm you are using the most recent link provided by your employer.',
 
  PORTAL_NOT_FOUND:          'Electronic delivery has not been set up for your employer. Please contact your HR department.',
 PORTAL_INACTIVE:            'Employee portal is currently inactive.',
  PORTAL_URL_NOT_CONFIGURED: 'The portal has not been fully configured for your employer. Please contact your HR department.',
  NO_SESSION:                'This link is not valid. Please use the link from your email to start again.',
  SESSION_EXPIRED:           'Your session has expired. Please try again.',
  RATE_LIMIT_EXCEEDED:       'Too many requests from your network. Please try again after 10 minutes.',
  
  ATTEMPT_FAILURE:            'Too many unsuccessful login attempts. Please try again after 15 minutes.',
  UNKNOWN_ERROR:             'An unexpected error occurred. Please try again or contact your employer.',
};
